export default class ProductMapPricing {
	constructor({
		product_info,
		customer_logged_in,
		customer_is_approved,
		product_in_cart,
		adv_source
	}) {
		this.selectors = {
			prices: '.js-product-price-label',
			map_prices: '.js-product-map-price',
			map_show: '.js-map-show',
			map_hide: '.js-map-hide',
			map_remove: '.js-map-remove',
			approved_show: '.js-map-approved-show',
			approved_remove: '.js-map-approved-remove'
		};

		this.settings = window.SiteSettings || {};
		this.product_info = {
			...window.ProductSettings,
			...product_info,
			product_in_cart,
			adv_source
		};
		this.customer_logged_in = customer_logged_in;
		this.customer_is_approved = customer_is_approved;
		this.list_price = this.product_info.DynamicNumbers.price;
		this.is_list_price = false;

		this.init();

		document.dispatchEvent(new CustomEvent('map-pricing:ready'));
	}

	init () {
		if (!this.is_list_price) {
			this.checkMap();
			if (this.is_list_price) {
				this.updatePrice();
				this.showPrices();

				const map_pricing = new CustomEvent('show-retail-prices');
				document.dispatchEvent(map_pricing);
				localStorage.setItem('productPricing', 'retail');
			} else {
				localStorage.setItem('productPricing', 'map');
			}
		}
	}

	checkMap() {
		let show_list_for_approved = false;

		if (this.product_info.MapPolicy.ShowRetailPriceForApprovedCustomer && this.customer_is_approved) {
			show_list_for_approved = true;
		}

		if (this.customer_logged_in) {
			this.is_list_price = true;
		}

		if (
			this.product_info.MapPolicy.ShowRetailPriceForCustomerAtProduct === false &&
			!show_list_for_approved
		) {
			this.is_list_price = false;
			this.list_price = this.product_info.DynamicNumbers.map_price;
		}
	}

	updatePrice() {
		const price = String(this.list_price.money());
		const prices = document.querySelectorAll(this.selectors.prices);

		prices.forEach(elem => {
			elem.textContent = price;
			elem.setAttribute('data-price', this.list_price);
		});
	}

	showPrices() {
		const price = String(this.list_price.money());

		this.changeElementsClass(this.selectors.map_show, 'd-none', 'remove');
		this.changeElementsClass(this.selectors.map_hide, 'd-none', 'add');
		this.removeElements(this.selectors.map_remove);

		if (this.customer_is_approved) {
			this.changeElementsClass(this.selectors.approved_show, 'd-none', 'remove');
			this.removeElements(this.selectors.approved_remove);
		}

		document.querySelectorAll(this.selectors.map_prices).forEach(el => {
			el.textContent = price;
		});
	}

	recalculatePrice() {
		const retail_price = parseFloat(String(this.list_price).replace(',', ''));

		if (window.product_options) {
			window.product_options.start_price = retail_price;
			window.product_options.recalculate_total_price();
		}
	}

	changeElementsClass (selector, css_class, action) {
		const els = document.querySelectorAll(selector);

		if (els.length > 0) {
			els.forEach(el => {
				switch (action) {
					case 'add':
						el.classList.add(css_class);
						break;
					case 'remove':
						el.classList.remove(css_class);
						break;
				}
			});
		}
	}

	removeElements (selector) {
		const els = document.querySelectorAll(selector);

		if (els.length > 0) {
			els.forEach(el => {
				el.remove();
			});
		}
	}
}
